import { render, staticRenderFns } from "./PairLockList.vue?vue&type=template&id=39a57cf8&scoped=true&"
import script from "./PairLockList.vue?vue&type=script&lang=ts&"
export * from "./PairLockList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a57cf8",
  null
  
)

export default component.exports